export default __webpack_public_path__ + "static/media/paulaBannerman.d2e19e4e.jpeg";